// PageWrapperAuto.js
import React from 'react';

export default function PageWrapper({ children }) {
  return <div className="App page">{children}</div>;
}
